<div
  class="grid"
  style="
--grid-display: {{ display }};
--grid-display-lg: {{ displayLg }};
--grid-display-md: {{ displayMd }};
--grid-display-sm: {{ displaySm }};
--grid-display-xs: {{ displayXs }};
--grid-template: {{ template }};
--grid-template-lg: {{ templateLg }};
--grid-template-md: {{ templateMd }};
--grid-template-sm: {{ templateSm }};
--grid-template-xs: {{ templateXs }};
--grid-direction: {{ direction }};
--grid-direction-lg: {{ directionLg }};
--grid-direction-md: {{ directionMd }};
--grid-direction-sm: {{ directionSm }};
--grid-direction-xs: {{ directionXs }};
--grid-align: {{ align }};
--grid-align-lg: {{ alignLg }};
--grid-align-md: {{ alignMd }};
--grid-align-sm: {{ alignSm }};
--grid-align-xs: {{ alignXs }};
--grid-justify: {{ justify }};
--grid-justify-lg: {{ justifyLg }};
--grid-justify-md: {{ justifyMd }};
--grid-justify-sm: {{ justifySm }};
--grid-justify-xs: {{ justifyXs }};
--grid-wrap: {{ wrap }};
--grid-wrap-lg: {{ wrapLg }};
--grid-wrap-md: {{ wrapMd }};
--grid-wrap-sm: {{ wrapSm }};
--grid-wrap-xs: {{ wrapXs }};
--grid-gap: {{ gapFinal }};
--grid-gap-lg: {{ gapFinalLg }};
--grid-gap-md: {{ gapFinalMd }};
--grid-gap-sm: {{ gapFinalSm }};
--grid-gap-xs: {{ gapFinalXs }};
--grid-padding: {{ padding }};
--grid-padding-lg: {{ paddingLg }};
--grid-padding-md: {{ paddingMd }};
--grid-padding-sm: {{ paddingSm }};
--grid-padding-xs: {{ paddingXs }};
--grid-margin: {{ margin }};
--grid-margin-lg: {{ marginLg }};
--grid-margin-md: {{ marginMd }};
--grid-margin-sm: {{ marginSm }};
--grid-margin-xs: {{ marginXs }};
"
  [ngStyle]="{ width: width, 'max-width': maxWidth }"
>
  <ng-content></ng-content>
</div>
